export class ZonePageUrlProvider {
  constructor(
    public zoneUrlInput: string,
    public pageUrlInput: string,
    public role?: string,
    public subscription?: string,
    public id?: string,
  ) {}
}
